export enum ExternalLinksStatus {
  SUBMIT_DISABLED = 'SUBMIT_DISABLED',
  SUBMIT_DISABLED_WITH_ERROR = 'SUBMIT_DISABLED_WITH_ERROR',
  SUBMIT_ENABLED = 'SUBMIT_ENABLED',
  LOADING = 'LOADING',
}
